import request from '../request'

export default {
  sendImageTelegram: function (data) {
    return request.post('image', data)
  }
}
